<div class="h-screen grid grid-cols-1 md:grid-cols-[3fr_2fr]">
  <div class="pt-36">
    <ng-container *ngIf="codigoConfirmado; else verificarCodigo">
      <header class="flex flex-col w-full items-center mt-4 px-20">
        <img src="assets/icon/codijobs.png" class="h-14" alt="" />
        <h1 class="text-3xl font-bold text-gray-700">
          ¡Bienvenido a <span class="text-primary">Codijobs</span>!
        </h1>
        <p class="text-gray-700 text-center px-6 md:px-20 mt-14">
          Nos alegra tenerte con nosotros. Te aconsejamos completar tu perfil en
          la sección
          <span class="text-primary font-semibold">Mi Perfil</span>
          para que los reclutadores puedan encontrarte más rápido.
          <br /><br />
          Explora oportunidades, conecta con empresas y empieza tu camino
          profesional ahora mismo.
        </p>
        <button
          (click)="goToHome()"
          class="mt-8 bg-primary hover:bg-primary/90 transition-transform duration-300 hover:scale-105 text-white font-semibold px-6 py-3 rounded-md shadow"
        >
          Empezar a buscar empleos
        </button>
      </header>
    </ng-container>
    <ng-template #verificarCodigo>
      <header class="flex flex-col w-full items-center mt-4">
        <img src="assets/icon/codijobs.png" class="h-14" alt="" />
        <h1 class="text-3xl font-bold text-gray-700">
          Verifica tu <span class="text-primary">Correo</span>
        </h1>
        <p class="text-md mt-2 text-gray-700 flex text-center">
          Se ha enviado un código de verificación al correo: <br />{{
            email
          }}
        </p>
      </header>
      <section class="flex-1 mt-10 flex flex-col items-center justify-between">
        <p class="mt-2 text-xl text-gray-600 mb-8">
          Ingresa el código de 6 dígitos enviado
        </p>
        <form
          [formGroup]="form"
          (ngSubmit)="onSubmit()"
          class="flex flex-col gap-y-10 px-4 sm:px-0"
        >
          <div class="flex gap-4 overflow-x-auto px-4">
            <ng-container *ngFor="let ctrl of codeControls; let i = index">
              <input
                id="code-{{ i }}"
                type="text"
                maxlength="1"
                [formControl]="ctrl"
                (input)="onInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                class="w-10 sm:w-14 h-12 sm:h-14 text-center text-2xl font-bold border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </ng-container>
          </div>
          <app-loading-button
            [text]="'Confirmar'"
            [loading]="loading"
            type="submit"
            class="w-full sm:w-auto px-6 py-3 mt-4"
          >
          </app-loading-button>
        </form>
      </section>
    </ng-template>
  </div>
  <div class="hidden relative md:block">
    <img
      src="assets/img/abs1.jpg"
      alt="Imagen decorativa"
      class="w-full h-full object-cover absolute"
    />
  </div>
</div>
